import { Button } from '@nextui-org/react'
import plusIcon from '../../assets/icons/plusIcon.png'

export const AddSelectSchools = () => {
  return (
    <Button size="sm" isIconOnly className="bg-tdpllightgrey">
      <img src={plusIcon} alt="" className="w-[1.5rem]" />
    </Button>
  )
}
